<div *ngIf="loggedInUser$| async" class="user-info">
  User: {{(loggedInUser$ | async)?.displayName}}
  <button mat-stroked-button (click)="logout()">Logout</button>
</div>
